import { put, call, all, select } from 'redux-saga/effects';
import {
  TOTAL_WEALTH_PROFILE_SIMULATION,
  WIZARD_UPDATE_DATA,
  CLIENT_DASHBOARD_GET,
  ACCOUNT_TOTAL_WEALTH_CHART_GET,
  CLIENT_DETAILS_GET,
  CLIENT_DETAILS_PATCH,
  CLIENT_ACCOUNTS_GET,
  CLIENT_ASSETS_BREAKDOWN_GET,
} from '../actions/types';
import { apiTotalWealthProfileSimulation, apiClientDetailsPatch } from '../api/client';
import { createQadraSaga } from './shared';
import { selectAccount } from '../selectors/accounts';
import { walletWithTransactionsGet } from './wallets';
import { actionModalOpen } from '../actions';
import { apiUserAccountsGet, apiUserDetailsGet, USER_TYPES_CLIENT } from '../api/user';
import { apiClientAssetsBreakdownGet } from '../api/client';
import { accountInvestmentObjectivesGet } from './investmentObjectives';

export function* totalWealthProfileSimulation({
  payload: {
    initialInvestment,
    investmentPeriod,
    monthlySalary,
    monthlyOtherIncome,
    otherAssets,
    otherFinancialInvestments,
    monthlyCostOfLiving,
    monthlyFixedExpenses,
    mortgage,
    otherLiabilities,
    strategyReturn,
    strategyVolatility,
    averageYearlyInvestment,
  },
}) {
  const { chart } = yield call(apiTotalWealthProfileSimulation, {
    initialInvestment,
    investmentPeriod,
    monthlySalary,
    monthlyOtherIncome,
    otherAssets,
    otherFinancialInvestments,
    monthlyCostOfLiving,
    monthlyFixedExpenses,
    mortgage,
    otherLiabilities,
    strategyReturn,
    strategyVolatility,
    averageYearlyInvestment,
  });

  yield put({
    type: WIZARD_UPDATE_DATA,
    payload: {
      totalWealth: {
        initialInvestment,
        investmentPeriod,
        monthlySalary,
        monthlyOtherIncome,
        otherAssets,
        otherFinancialInvestments,
        monthlyCostOfLiving,
        monthlyFixedExpenses,
        mortgage,
        otherLiabilities,
        strategyReturn,
        strategyVolatility,
        averageYearlyInvestment,
        chart,
      },
    },
  });
}

const watchTotalWealthProfileSimulation = createQadraSaga(totalWealthProfileSimulation, {
  action: TOTAL_WEALTH_PROFILE_SIMULATION._REQUEST,
});

function* clientDashboardGet(action) {
  const { accountId } = action.payload;
  const calls = [
    accountInvestmentObjectivesGet,
    // accountPortfolioProposalsGet,
    // accountPortfoliosGet,
    walletWithTransactionsGet,
  ];

  yield all(calls.map((c) => call(c, action)));

  const account = yield select(selectAccount, accountId);
  const wallets = yield select((state) => state.wallets.items[accountId]);

  let sumOtherAssets = account.financialAssets.otherAssets;
  if (wallets && wallets[0]) {
    sumOtherAssets += wallets[0].amount;
  }

  const { chart } = yield call(apiTotalWealthProfileSimulation, {
    initialInvestment: account.investmentObjectives.initialInvestment,
    investmentPeriod: account.investmentObjectives.investmentPeriod,
    averageYearlyInvestment: account.investmentObjectives.averageYearlyInvestment,
    monthlySalary: account.financialAssets.monthlySalary,
    monthlyOtherIncome: account.financialAssets.monthlyOtherIncome,
    otherAssets: sumOtherAssets,
    otherFinancialInvestments: account.financialAssets.otherFinancialInvestments,
    monthlyCostOfLiving: account.lifestyleCosts.monthlyCostOfLiving,
    monthlyFixedExpenses: account.lifestyleCosts.monthlyFixedExpenses,
    mortgage: account.lifestyleCosts.mortgage,
    otherLiabilities: account.lifestyleCosts.otherLiabilities,
    strategyReturn: account.acceptedPortfolioProposal.kpis.return,
    strategyVolatility: account.acceptedPortfolioProposal.kpis.volatility,
  });

  yield put({
    type: ACCOUNT_TOTAL_WEALTH_CHART_GET._SUCCESS,
    payload: { chart, accountId: action.payload.accountId },
  });
}

const watchClientDashboardGet = createQadraSaga(clientDashboardGet, {
  action: CLIENT_DASHBOARD_GET._REQUEST,
});

function* clientDetailsGet({ payload: { clientId } }) {
  const { detail } = yield call(apiUserDetailsGet, { id: clientId, userType: USER_TYPES_CLIENT });

  yield put({
    type: CLIENT_DETAILS_GET._SUCCESS,
    payload: { clientDetails: detail },
  });
}

const watchClientDetailsGet = createQadraSaga(clientDetailsGet, {
  action: CLIENT_DETAILS_GET._REQUEST,
});

function* clientAccountsGet({ payload: { clientId } }) {
  const { accounts } = yield call(apiUserAccountsGet, clientId);

  yield put({
    type: CLIENT_ACCOUNTS_GET._SUCCESS,
    payload: { clientId, accounts },
  });
}

const watchClientAccountsGet = createQadraSaga(clientAccountsGet, {
  action: CLIENT_ACCOUNTS_GET._REQUEST,
});

function* clientDetailsPatch({ payload: { clientId, allowFaOnboarding } }) {
  yield call(apiClientDetailsPatch, clientId, {
    allowFaOnboarding,
  });

  yield clientDetailsGet({ payload: { clientId } });

  yield put(actionModalOpen('ModalConfirmDelegatedProfiling'));
}

const watchClientDetailsPatch = createQadraSaga(clientDetailsPatch, {
  action: CLIENT_DETAILS_PATCH._REQUEST,
});

function* clientAssetsBreakdown({ payload: { clientId, types, relationshipType } }) {
  const { breakdowns } = yield call(apiClientAssetsBreakdownGet, clientId, types, relationshipType);

  yield put({
    type: CLIENT_ASSETS_BREAKDOWN_GET._SUCCESS,
    payload: { clientId, breakdowns },
  });
}

const watchClientAssetsBreakdownGet = createQadraSaga(clientAssetsBreakdown, {
  action: CLIENT_ASSETS_BREAKDOWN_GET._REQUEST,
});

export default [
  watchTotalWealthProfileSimulation,
  watchClientDashboardGet,
  watchClientDetailsGet,
  watchClientDetailsPatch,
  watchClientAccountsGet,
  watchClientAssetsBreakdownGet,
];
